import { render, staticRenderFns } from "./InsightSidebar.vue?vue&type=template&id=5eca307c&scoped=true&"
import script from "./InsightSidebar.vue?vue&type=script&lang=js&"
export * from "./InsightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InsightSidebar.vue?vue&type=style&index=0&id=5eca307c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eca307c",
  null
  
)

export default component.exports